import { render, staticRenderFns } from "./RotatesManager.vue?vue&type=template&id=2bf553b3&"
import script from "./RotatesManager.vue?vue&type=script&lang=ts&"
export * from "./RotatesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports